'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import { ENTERPRISE } from 'self-service-api/constants/ProductLevels';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { currentSkuIdForProductSelector, upgradeProductSelector } from '../../selectors/ProductsSelectors';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { APP } from '../../constants/AuthType';
import { MERCH_CARD, SUBSCREENS } from '../../constants/Tracking';
import PriceDisplay from '../common/pricing/PriceDisplay';
import BannerTalkToSalesButton from './BannerTalkToSalesButton';
import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';

const MarketingHubEntPriceChangeBanner = () => {
  const currencyCode = useSelector(activeCurrencySelector);
  const prices = {
    [CurrencyCodes.USD]: 3600,
    [CurrencyCodes.EUR]: 3300,
    [CurrencyCodes.GBP]: 3000,
    [CurrencyCodes.AUD]: 5200,
    [CurrencyCodes.SGD]: 5100,
    [CurrencyCodes.JPY]: 432000,
    [CurrencyCodes.COP]: 10800000,
    [CurrencyCodes.CAD]: 4700
  };
  const price = prices[currencyCode];
  const skuId = useSelector(state => {
    return currentSkuIdForProductSelector(state, {
      productLine: MARKETING,
      productLevel: ENTERPRISE
    });
  });
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: [skuId]
  }));
  const upgradeData = {
    app: APP,
    screen: SUBSCREENS.MARKETING_HUB,
    uniqueId: `${MERCH_CARD}-${ENTERPRISE.toLowerCase()}`,
    upgradeProduct
  };
  return /*#__PURE__*/_jsx(UIAlert, {
    titleText: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "marketingEnterprisePriceChange.alternativeTitle_jsx",
      elements: {
        Price: PriceDisplay
      },
      options: {
        currencyCode,
        price
      }
    }),
    children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketingEnterprisePriceChange.body"
      }), /*#__PURE__*/_jsx(BannerTalkToSalesButton, {
        productConfigurations: [createProductConfig({
          skuId
        })],
        upgradeData: upgradeData
      })]
    })
  });
};

export default MarketingHubEntPriceChangeBanner;